import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const DeleteTemplateDialog = ({
  open,
  handleClose,
  handleSubmit
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>{t("importCSV.removeTemplate")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("importCSV.removeTemplateConfirm")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("abort")}
        </Button>
        <Button onClick={handleSubmit} color="primary" data-cy="remove-template-confirm">
          {t("remove")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTemplateDialog;
